import { Inject } from 'inversify-props';
import { ConfiguracaoDeCupomServiceAdapter } from './adapter';

export class DeleteConfiguracaoDeCupomUseCase {
	@Inject('ConfiguracaoDeCupomServiceAdapter')
	private configuracaoDeCupomServiceAdapter!: ConfiguracaoDeCupomServiceAdapter

	deleteById = async (id: string): Promise<void> =>
		await this.configuracaoDeCupomServiceAdapter.delete(id)
}